
export const UserRole = {
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  USER: "USER",
  CARETAKER: "CARETAKER",
  SURVEY_REVIEWER: "SURVEY_REVIEWER",
}
